<template>
  <div>
    <email :userId="userId"></email>
  </div>
</template>
<script>
import email from '@/components/account/EmailPwd.vue'
export default {
  name: 'emailPwd',
  components: {
    'email': email
  },
  data() {
    return {
      userId: ''
    }
  },
  mounted() {
    this.userId = this.$route.query.userId
  },
  methods: {

  }
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/page/EmailPwd.vue